__turbopack_context__.v({
  "actionButton": "c7ZL3a_actionButton",
  "description": "c7ZL3a_description",
  "leftSection": "c7ZL3a_leftSection",
  "refreshButton": "c7ZL3a_refreshButton",
  "refreshIcon": "c7ZL3a_refreshIcon",
  "title": "c7ZL3a_title",
  "titleRow": "c7ZL3a_titleRow",
  "wrapper": "c7ZL3a_wrapper",
});
